<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xi">NOTE ON TRANSLITERATION</a></p><a id="page_xi">
<p class="noindent">Moroccan dialectical Arabic (<i>darija</i>) varies from region to region and does not have a standardized written form, unlike Modern Standard Arabic. For words from Modern Standard Arabic, I have relied on the <i>International Journal for Middle East Studies</i>. For darija, I refer to Heath 1987 and Harrell 1962 for transliteration. Where there are standard spellings for words that occur in English texts, such as <i>tagine</i> or <i>Alaoui</i>, I use the Anglicized versions. I have followed those guidelines. Diacritics that do not occur in English have been simplified to make them accessible to readers.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Fm02.vue?7aebdb00